import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../api/api.service';
import { LocalserviceService } from '../../../api/localservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";

@Component({
  selector: 'app-itibtn',
  templateUrl: './itibtn.component.html',
  styleUrls: ['./itibtn.component.css']
})
export class ItibtnComponent implements OnInit {

  itiForm: any;
  submittedIti = false;

  public pduTable: any;

  reciveiticode:any = window.localStorage.getItem('ITICode');

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router, private httpClient: HttpClient, private Local: LocalserviceService) {
    this.Local.get_login_data().subscribe((result: any) => {    
      console.log(result);

  
    });
   }

  ngOnInit(): void {
    this.itiForm = this.formBuilder.group({
      iticode: ['', Validators.required],
    });
  }

  get h() {
    return this.itiForm.controls;
  }

  onItiSubmit(){
    this.submittedIti = true;

    if (this.itiForm.invalid) {
      return;
    }

  this.api.checkApiTable(this.itiForm.value).subscribe((result: any) => {
    console.log(result[0]['count']);
    let count = result[0]['count'];
 
    if(count == 0){
      alert(" data Insert ");
      this.api.checkApi(this.itiForm.value).subscribe((result: any) => {
        this.pduTable = result;
        console.log(JSON.stringify(result))
        this.api.importTableAll(this.pduTable).subscribe((result: any) => {
          
          let status = result.status;
          console.log(status)
          if(status == 'succes'){
            alert("Sucess");
           
          }
          else{
            alert("someting went wrong pls login")
          }
        

        });
        
        
  
      });
    }
    else{
       alert("Already Upload data");
       //this.Local.set_login_data(args);      
       this.router.navigateByUrl('/examfeeiti/examitishow');
    }
  });


  }

}
